import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { KibbleThemeProvider } from '@televet/kibble-ui';
import { Flex } from '@televet/kibble-ui/chakra';
import { AuthContext } from '@/providers/auth';
import { TrackingProvider } from '@/providers/tracking';
import { AstroInternalTRPCProvider } from '@/providers/trpc';

interface RouterContext {
  auth: AuthContext;
  pageTitle?: string;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <AstroInternalTRPCProvider>
      <KibbleThemeProvider>
        <TrackingProvider>
          <Flex className="RootLayout" h="100dvh" w="100%">
            <Outlet />
          </Flex>
        </TrackingProvider>
      </KibbleThemeProvider>
    </AstroInternalTRPCProvider>
  );
}
